import { AccordionContext } from '@unifyapps/ui/components/Accordion';
import { Checkbox } from '@unifyapps/ui/components/Checkbox';
import { Divider } from '@unifyapps/ui/components/Divider';
import { Stack } from '@unifyapps/ui/components/Stack';
import { Typography } from '@unifyapps/ui/components/Typography';
import React, { useContext } from 'react';
import type { NotificationEventType } from '../../types';

type Props = {
  channelTypes: { id: string; name: string }[];
  events: NotificationEventType[];
  onToggleEvent: (groupName: string, eventType: string, channelType: string) => void;
  preferences: Record<string, Record<string, boolean>> | undefined;
  groupId: string;
};

function EventsPreferences({ channelTypes, events, onToggleEvent, preferences, groupId }: Props) {
  return events.map((eventType, index) => (
    <React.Fragment key={eventType.id}>
      <Stack className="ps-md py-md flex items-center justify-between pe-[66px]" direction="row">
        <Typography color="text-tertiary" variant="text-sm" weight="regular">
          {eventType.name}
        </Typography>
        {channelTypes.map((channelType) => (
          <Checkbox
            checked={Boolean(preferences?.[eventType.id][channelType.id])}
            className="w-8xl"
            key={channelType.id}
            onChange={() => onToggleEvent(groupId, eventType.id, channelType.id)}
          />
        ))}
      </Stack>
      {index !== events.length - 1 ? <Divider color="border-tertiary" /> : null}
    </React.Fragment>
  ));
}

function EventsPreferencesContainer({
  events,
  channelTypes,
  onToggleEvent,
  preferences,
  groupId,
}: Props) {
  const { expanded = false } = useContext(AccordionContext);

  if (!expanded) {
    return null;
  }

  return (
    <EventsPreferences
      channelTypes={channelTypes}
      events={events}
      groupId={groupId}
      onToggleEvent={onToggleEvent}
      preferences={preferences}
    />
  );
}

export { EventsPreferencesContainer as EventsPreferences };
